<div *ngIf="detailForm" class="form-modal">
  <h1 mat-dialog-title>{{'LINE_DETAILS'|translate}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="detailForm" class="form-horizontal modal-dialog-custom">
      <div class="row">

        <!-- Panel identificacao da linha -->
        <div class="col-md-12">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn1"
              (click)="collPn1 = !collPn1">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'PRODUCT' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn1, 'fa-caret-up': !collPn1}"></i>
              </h5>
            </div>
            <div id="collPn1" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Num linha -->
                <div class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.LineNumber.valid}">
                    <mat-label>{{ 'LINE_NUMBER' | translate}}</mat-label>
                    <input matInput formControlName="LineNumber">
                  </mat-form-field>
                  <span *ngIf="formErrors.LineNumber" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.LineNumber">{{
                    formErrors.LineNumber }}</span>
                </div>
                <!-- Cod cliente -->
                <div class="col-md-3 col-sm-12" *ngIf="!hideBuyerProductCode">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.BuyerProductCode.valid}">
                    <mat-label>{{ 'CLIENT_CODE' | translate}}</mat-label>
                    <input matInput formControlName="BuyerProductCode">
                  </mat-form-field>
                  <span *ngIf="formErrors.BuyerProductCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.BuyerProductCode">{{
                    formErrors.BuyerProductCode }}</span>
                </div>
                <!-- Cod fornecedor -->
                <div class="col-md-3 col-sm-12" *ngIf="!hideSupplierProductCode">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.SupplierProductCode.valid}">
                    <mat-label>{{ 'SELLER_CODE' | translate}}</mat-label>
                    <input matInput formControlName="SupplierProductCode">
                  </mat-form-field>
                  <span *ngIf="formErrors.SupplierProductCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.SupplierProductCode">{{
                    formErrors.SupplierProductCode }}</span>
                </div>
                <!-- Cod EAN -->
                <div class="col-md-3 col-sm-12" *ngIf="!hideEANCode">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.StandardProductCode.valid}">
                    <mat-label>{{ 'EANCODE' | translate}}</mat-label>
                    <input matInput formControlName="StandardProductCode">
                  </mat-form-field>
                  <span *ngIf="formErrors.StandardProductCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.StandardProductCode">{{
                    formErrors.StandardProductCode }}</span>
                </div>
                <!-- Linha encomenda -->
                <div class="col-md-3 col-sm-12" *ngIf="showOrderLineNumberOnProductPanel">
                  <mat-form-field class='allwidth'
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.BuyersOrderLineNumber.valid}">
                    <mat-label>{{ 'ORDER_LINE' | translate}}</mat-label>
                    <input matInput formControlName='BuyersOrderLineNumber'>
                  </mat-form-field>
                  <span *ngIf='formErrors.BuyersOrderLineNumber' class='field-validation-valid text-danger'
                    [translate]>{{
                    formErrors.BuyersOrderLineNumber
                    }}
                  </span>
                </div>

                <!-- Centro de custo -->
                <div class="col-md-3 col-sm-12" *ngIf="showCostCenter">
                  <cost-center-modal formControlName="CostCenterID" 
                    (change)="onCostCenterChange($event)"
                    [enabled]="detailForm.enabled"></cost-center-modal>
                </div>

                <!-- Espaço -->
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Descricao -->
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.ProductDescription.valid}">
                    <mat-label>{{ 'DESCRIPTION' | translate}}</mat-label>
                    <ng-container *ngIf="showDescriptionAsTextArea">
                      <textarea matInput formControlName="ProductDescription">
                      </textarea>
                      </ng-container>
                      <ng-container *ngIf="!showDescriptionAsTextArea">
                    <input matInput formControlName="ProductDescription">
                  </ng-container>
                  </mat-form-field>
                  <span *ngIf="formErrors.ProductDescription" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.ProductDescription">{{formErrors.ProductDescription}}</span>
                </div>

                <!-- Nº Proposta Aprovada -->
                <div class="col-md-2 col-sm-12" *ngIf="showApprovedProposalNumber">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'APPROVED_PROPOSAL_NUMBER' | translate}}</mat-label>
                    <input matInput
                      formControlName="ApprovedProposalNumber">
                  </mat-form-field>
                  <span *ngIf="formErrors.ApprovedProposalNumber" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.ApprovedProposalNumber">{{ formErrors.ApprovedProposalNumber
                    }}</span>
                </div>

                <div *ngIf="showProductServiceTypeFields">
                  <!-- Espaço -->
                  <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                  <div class="col-md-3 col-sm-12">
                    <mat-form-field class="allwidth">
                      <mat-label>{{ 'PRODUCT_SERVICE_TYPE' | translate}}</mat-label>
                      <input matInput formControlName="AccountProductTypeDescription" class="one" readonly>
                        <i matSuffix class="glyphicon glyphicon-new-window" (click)="setAccountProductType()" *ngIf="!detailForm.get('AccountProductType').disabled"></i>
                    </mat-form-field>
                  </div>
                  <div class="col-md-3 col-sm-12">
                    <mat-form-field class="allwidth">
                      <mat-label>{{ 'VAT_TREATMENT_TYPE' | translate}}</mat-label>
                      <mat-select formControlName="VatTreatmentType"
                        (selectionChange)="onChangeVatTreatmentType($event)">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let prod of vatTreatmentTypes" [value]="prod.ItemCode">{{prod.ItemName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-3 col-sm-12">
                    <mat-form-field class="allwidth">
                      <mat-label>{{ 'PRODUCT_SERVICE_SUBTYPE' | translate}}</mat-label>
                      <input matInput formControlName="AccountProductSubtypeDescription" [ngClass]="'one'" readonly>
                        <i matSuffix class="glyphicon glyphicon-new-window" (click)="setAccountProductSubtype()" *ngIf="!detailForm.get('AccountProductSubtype').disabled"></i>
                    </mat-form-field>
                  </div>
                </div>
                <!-- Espaço -->
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                                
                <!-- Código Centro Custo -->
                <div *ngIf="useProductCostCenter" class="col-md-3 col-sm-12">
                    <mat-form-field class="allwidth">
                      <mat-label>{{ 'COST_CENTER' | translate}}</mat-label>
                    <input matInput
                        value="{{ this.costCenter.description }}"
                        class="one" readonly="true" [disabled]="costCenterList.length == 0 || !enableSaveButton">
                        <i matSuffix class="glyphicon glyphicon-new-window" (click)="selectCostCenter()" *ngIf="costCenterList.length >= 1 && enableSaveButton"></i>
                    </mat-form-field>
                </div>
                
                <!-- Código Reclassificação -->
                <div *ngIf="useProductReclassificationCode" class="col-md-3 col-sm-12">
                    <mat-form-field class="allwidth">
                      <mat-label>{{ 'RECLASSIFICATION_CODE' | translate}}</mat-label>
                    <input matInput
                        value="{{ this.reclassificationCode.description }}"
                        class="one" readonly="true" [disabled]="reclassificationCodeList.length == 0 || !enableSaveButton">
                        <i matSuffix class="glyphicon glyphicon-new-window" (click)="selectRecCode()" *ngIf="reclassificationCodeList.length >= 1 && enableSaveButton"></i>
                    </mat-form-field>
                </div>

                <!-- Processo -->
                <div class="col-md-3 col-sm-12" *ngIf="showOrderProcess && detailForm.controls['Process'] && detailForm.controls['OrderType'] && detailForm.controls['OrderType'].value == 'PropertiesOrder'">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'PROCESS_' | translate}}</mat-label>
                    <input matInput
                      formControlName="Process"
                      class="one">
                  </mat-form-field>
                </div>
                
                <!-- Fração -->
                <div class="col-md-3 col-sm-12" *ngIf="showOrderFraction  && detailForm.controls['Fraction'] && detailForm.controls['OrderType'] && detailForm.controls['OrderType'].value == 'PropertiesOrder'">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'FRACTION' | translate}}</mat-label>
                    <input matInput
                      formControlName="Fraction"
                      class="one">
                  </mat-form-field>
                </div>

                <!-- Espaço -->
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                
                <!-- Botão distibuição -->
                <div *ngIf="showDistributionButton || (showCostCenterDistributionDetails && !hasDetailsWithCostCenterDistributions)" class="col-md-2 col-sm-12">
                  <button type="button" class="btn btn-primary" (click)="showCostCenterDistributionDetails ? openCostCenterDistribution() : openDistribution()">
                    {{ distributionButtonLabel | translate}}&nbsp;
                    <i *ngIf="hasDistribution" class="fas fa-check"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel Datas -->
        <div class="col-md-12" *ngIf="showDatesPanel">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn9"
              (click)="collPn9 = !collPn9">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'DATES' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn9, 'fa-caret-up': !collPn9}"></i>
              </h5>
            </div>
            <div id="collPn9" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Data Início -->
                <div class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.StartDate.valid}">
                    <mat-label>{{ 'BEGIN_DATE' | translate}}</mat-label>
                    <input matInput formControlName="StartDate"
                      class="one date-picker"
                      (onChangeDatePicker)="onValueChangedDetails()">
                      <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                  </mat-form-field>
                  <span *ngIf='formErrors.StartDate' class='field-validation-valid text-danger' [translate]
                    [translateParams]="formErrorsParam.StartDate">{{
                    formErrors.BuyersOrderDate }}</span>
                </div>
                <!-- Data Fim -->
                <div class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.EndDate.valid}">
                    <mat-label>{{ 'END_DATE' | translate}}</mat-label>
                    <input matInput formControlName="EndDate"
                      class="one date-picker"(onChangeDatePicker)="onValueChangedDetails()">
                      <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                  </mat-form-field>
                  <span *ngIf='formErrors.EndDate' class='field-validation-valid text-danger' [translate]
                    [translateParams]="formErrorsParam.EndDate">{{
                    formErrors.EndDate }}</span>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Panel quantidade -->
        <div [ngClass]="commonService.useClassBasedOnSetting(useHalfColumn,'col-md-12','col-md-6')">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn2"
              (click)="collPn2 = !collPn2">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'QUANTITIES' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn2, 'fa-caret-up': !collPn2}"></i>
              </h5>
            </div>
            <div id="collPn2" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Qtd encomendada -->
                <div class="col-sm-12" [ngClass]="commonService.useClassBasedOnSetting(useHalfColumn,'col-md-2','col-md-4')">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Quantity.valid}">
                    <mat-label>{{ 'QUANTITY' | translate}}</mat-label>
                    <input matInput formControlName="Quantity"
                      class="text-right" (change)="valueCalDiscTax();onQuantityChange()">
                  </mat-form-field>
                  <span *ngIf="formErrors.Quantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.Quantity">{{
                    formErrors.Quantity }}</span>
                </div>
                <!-- Qtd encomendada UM -->
                <div class="col-sm-12" [ngClass]="commonService.useClassBasedOnSetting(useHalfColumn,'col-md-2','col-md-4')">
                  <mat-form-field class="allwidth">
                    <mat-label>UM</mat-label>
                    <mat-select name="QuantityUOMCode" formControlName="QuantityUOMCode"
                      [ngClass]="{ 'mat-input-invalid': !detailForm.controls.QuantityUOMCode.valid}">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let inUn of invoiceUnMeasureG" [value]="inUn.Code">{{inUn.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span *ngIf="formErrors.QuantityUOMCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.QuantityUOMCode">{{
                    formErrors.QuantityUOMCode }}</span>
                </div>
                <!-- Qtd encomendada UM outra -->
                <div class="col-md-2 col-sm-12" *ngIf="detailForm.get('QuantityUOMCode').value == 'Other'">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.QuantityUOMOther.valid}">
                    <mat-label>UM - {{ 'OTHER' | translate}}</mat-label>
                    <input matInput formControlName="QuantityUOMOther">
                  </mat-form-field>
                  <span *ngIf="formErrors.QuantityUOMOther" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.QuantityUOMOther">{{
                    formErrors.QuantityUOMOther }}</span>
                </div>
                <!-- Qtd gratis -->
                <div class="col-md-2 col-sm-12" *ngIf="showBonusQuantity">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.BonusQuantity.valid}">
                    <mat-label>{{ 'FREE_QTT' | translate}}</mat-label>
                    <input matInput formControlName="BonusQuantity"
                      class="text-right" (change)="onBonusQuantityChange()">
                  </mat-form-field>
                  <span *ngIf="formErrors.BonusQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.BonusQuantity">{{
                    formErrors.BonusQuantity }}</span>
                </div>
                <!-- Qtd gratis UM -->
                <div class="col-md-2 col-sm-12" *ngIf="showBonusQuantityUOMCode">
                  <mat-form-field class="allwidth">
                    <mat-label>UM</mat-label>
                    <mat-select name="BonusQuantityUOMCode" formControlName="BonusQuantityUOMCode"
                      [ngClass]="{ 'mat-input-invalid': !detailForm.controls.BonusQuantityUOMCode.valid}">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let inUn of invoiceUnMeasureG" [value]="inUn.Code">{{inUn.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span *ngIf="formErrors.BonusQuantityUOMCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.BonusQuantityUOMCode">{{
                    formErrors.BonusQuantityUOMCode }}</span>
                </div>
                <!-- Qtd gratis UM outra -->
                <div class="col-md-2 col-sm-12"
                  *ngIf="detailForm.get('BonusQuantityUOMCode').value == 'Other' && showBonusQuantityUOMCode">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.BonusQuantityUOMOther.valid}">
                    <mat-label>UM - {{ 'OTHER' | translate}}</mat-label>
                    <input matInput formControlName="BonusQuantityUOMOther">
                  </mat-form-field>
                  <span *ngIf="formErrors.BonusQuantityUOMOther" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.BonusQuantityUOMOther">{{
                    formErrors.BonusQuantityUOMOther }}</span>
                </div>
                <!-- Qtd embalagens -->
                <div class="col-md-2 col-sm-12" *ngIf="showPackQuantity">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.PackQuantity.valid}">
                    <mat-label>{{ 'PACKAGES_QUANTITY' | translate}}</mat-label>
                    <input matInput formControlName="PackQuantity"
                      class="text-right" (change)="onPackageQuantityChange()">
                  </mat-form-field>
                  <span *ngIf="formErrors.PackQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.PackQuantity">{{
                    formErrors.PackQuantity }}</span>
                </div>
                <!-- Qtd embalagens UM -->
                <div class="col-md-2 col-sm-12" *ngIf="showPackQuantityUOMCode">
                  <mat-form-field class="allwidth">
                    <mat-label>UM</mat-label>
                    <mat-select name="PackQuantityUOMCode" formControlName="PackQuantityUOMCode"
                      [ngClass]="{ 'mat-input-invalid': !detailForm.controls.PackQuantityUOMCode.valid}">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let inUn of invoiceUnMeasureG" [value]="inUn.Code">{{inUn.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span *ngIf="formErrors.PackQuantityUOMCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.PackQuantityUOMCode">{{
                    formErrors.PackQuantityUOMCode }}</span>
                </div>
                <!-- Qtd embalagens UM outra -->
                <div class="col-md-2 col-sm-12"
                  *ngIf="detailForm.get('PackQuantityUOMCode').value == 'Other' && showPackQuantityUOMCode">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.PackQuantityUOMOther.valid}">
                    <mat-label>UM - {{ 'OTHER' | translate}}</mat-label>
                    <input matInput formControlName="PackQuantityUOMOther">
                  </mat-form-field>
                  <span *ngIf="formErrors.PackQuantityUOMOther" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.PackQuantityUOMOther">{{
                    formErrors.PackQuantityUOMOther }}</span>
                </div>

                <div class="col-md-3 col-sm-12" *ngIf="showPriceUnit">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'PRICE_UNIT' | translate}}</mat-label>
                    <input matInput formControlName="PriceUnit"
                      (change)="valueCalDiscTax();">
                  </mat-form-field>
                </div>
              
                <!-- Espaço -->
                <div class="col-md-12 col-xs-12 spacer-bottom-xs" *ngIf="showPackSize"></div>
                <!-- Qtd por embalagem -->
                <div class="col-md-3 col-sm-12" *ngIf="showPackSize">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.PackSize.valid}">
                    <mat-label>{{ 'QUANTITY_FOR_PACKAGES' | translate}}</mat-label>
                    <input matInput formControlName="PackSize"
                      class="text-right">
                  </mat-form-field>
                  <span *ngIf="formErrors.PackSize" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.PackSize">{{formErrors.PackSize}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel precos -->
        <div [ngClass]="commonService.useClassBasedOnSetting(useHalfColumn,'col-md-12','col-md-6')">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn3"
              (click)="collPn3 = !collPn3">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'PRICES' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn3, 'fa-caret-up': !collPn3}"></i>
              </h5>
            </div>
            <div id="collPn3" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Preco unit bruto -->
                <div class="col-md-2 col-sm-12" *ngIf="showGrossUnitPrice">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.GrossUnitPrice.valid}">
                    <mat-label>{{ 'GROSS_UNIT_PRICE' | translate}}</mat-label>
                    <input matInput formControlName="GrossUnitPrice"
                      class="text-right one" (change)="onChangeDetailGrossUnitPrice();">
                      <i matSuffix>{{_cur_symbol}}</i>
                  </mat-form-field>
                  <span *ngIf="formErrors.GrossUnitPrice" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.GrossUnitPrice">{{
                    formErrors.GrossUnitPrice }}</span>
                </div>
                <!-- Total bruto -->
                <div class="col-md-3 col-sm-12" *ngIf="showTotalGrossAmount">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.TotalGrossAmount.valid}">
                    <mat-label>{{ 'GROSS_TOTAL' | translate}}</mat-label>
                    <input matInput formControlName="TotalGrossAmount"
                      class="text-right one">
                      <i matSuffix>{{_cur_symbol}}</i>
                  </mat-form-field>
                  <span *ngIf="formErrors.TotalGrossAmount" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.TotalGrossAmount">{{
                    formErrors.TotalGrossAmount }}</span>
                </div>
                <!-- Preco unit liq -->
                <div class="col-sm-12" [ngClass]="commonService.useClassBasedOnSetting(useHalfColumn,'col-md-2','col-md-4')">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.NetUnitPrice.valid}">
                    <mat-label>{{ 'NET_UNIT_PRICE' | translate}}</mat-label>
                    <input matInput formControlName="NetUnitPrice"
                      class="text-right one" (change)="onChangeDetailNetUnitPrice();">
                      <i matSuffix>{{_cur_symbol}}</i>
                  </mat-form-field>
                  <span *ngIf="formErrors.NetUnitPrice" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.NetUnitPrice">{{
                    formErrors.NetUnitPrice }}</span>
                </div>
                <!-- Total Lid -->
                <div class="col-sm-12" [ngClass]="commonService.useClassBasedOnSetting(useHalfColumn,'col-md-3','col-md-6')">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.TotalNetAmount.valid}">
                    <mat-label>{{ 'NET_TOTAL' | translate}}</mat-label>
                    <input matInput formControlName="TotalNetAmount"
                      class="text-right one">
                      <i matSuffix>{{_cur_symbol}}</i>
                  </mat-form-field>
                  <span *ngIf="formErrors.TotalNetAmount" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.TotalNetAmount">{{
                    formErrors.TotalNetAmount }}</span>
                </div>
                
                <!-- Total transporte -->
                <div class="col-md-2 col-sm-12" *ngIf="showTotalTransportAmount">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.TotalTransportAmount.valid}">
                    <mat-label>{{ 'TRANSPORT_COST' | translate}}</mat-label>
                    <input matInput
                      formControlName="TotalTransportAmount" class="text-right one">
                      <i matSuffix>{{_cur_symbol}}</i>
                  </mat-form-field>
                  <span *ngIf="formErrors.TotalTransportAmount" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.TotalTransportAmount">{{
                    formErrors.TotalTransportAmount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel Impostos (Taxas) -->
        <div class="col-md-12">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn4"
              (click)="collPn4 = !collPn4">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'TAX_INFORMATION' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn4, 'fa-caret-up': !collPn4}"></i>
              </h5>
            </div>
            <div id="collPn4" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Lista taxas -->
                <div class="col-md-12 col-sm-12 no-padding">
                  <h6 class="padding-left-15 no-margin-top">
                    <button type="button" class="btn btn-sm" (click)="addTaxes(true)"
                      *ngIf="(!formDisabled && allDetailsEditable && ((this.invoiceType != 'CreditMemo' && this.invoiceType != 'CreditFinancial') || !disableTaxPanel)) && (invoiceTaxesTypes.length > 0)">
                      <span title="{{'ADD' | translate}}">
                        <i class="fas fa-plus-square color-success backwhite"></i>
                      </span>
                    </button>
                  </h6>
                  <!-- motivo de isencao -->
                  <div *ngIf="showVatExemption && !groupVatExemption" class="col-md-4 col-sm-12 pull-right">
                    <mat-form-field class="allwidth">
                      <mat-label>{{'REASON_FOR_EXEMPTION'|translate}}</mat-label>
                      <mat-select formControlName="VatExemptReasonID"
                        [ngClass]="{ 'mat-input-invalid': !detailForm.controls.VatExemptReasonID.valid}">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let item of invoiceValueAddedTaxesReasons" [value]="item.IntegrationID">
                          {{item.Norm}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <span *ngIf="formErrors.VatExemptReasonID" class="field-validation-valid text-danger" [translate]
                      [translateParams]="formErrorsParam.VatExemptReasonID">{{
                      formErrors.VatExemptReasonID }}</span>
                  </div>
                  <div *ngIf="showVatExemption && !groupVatExemption" class="col-md-12 col-sm-12 spacer-bottom-xs"></div>
                  <div class="table-responsive col-md-12 col-sm-12">
                    <div *ngIf="formErrorsTaxes.length>0" class="validation-summary-errors text-danger col-md-6">
                      <ul>
                        <li *ngFor="let errorMessage of formErrorsTaxes; let i = index" [translate]
                          [translateParams]="formErrorsTaxesParam[i]">{{errorMessage}}</li>
                      </ul>
                    </div>
                    <table class="table-bordered">
                      <thead>
                        <ng-container *ngIf="!hideColumsTax">
                        <tr>
                          <th width="12%" class="text-center">{{ 'TYPE' | translate}}</th>
                          <th width="12%" class="text-center">{{ 'SUBTYPE' | translate}}</th>
                          <th width="7%" class="text-center">{{ 'OTHER' | translate}}</th>
                          <th width="9%" class="text-center">%</th>
                          <th width="15%" class="text-center">{{ 'TAXABLE' | translate}}</th>
                          <th width="15%" class="text-center">{{ 'VALUE' | translate}}</th>
                          <th width="25%" class="text-center">{{ 'OBSERVATIONS' | translate}}</th>
                          <th class="text-center"></th>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="hideColumsTax">
                        <tr>
                          <th width="33%" class="text-center">{{ 'TYPE' | translate}}</th>
                          <th width="33%" class="text-center">%</th>
                          <th width="33%" class="text-center">{{ 'VALUE' | translate}}</th>
                          <th class="text-center"></th>
                        </tr>
                      </ng-container>
                      </thead>
                      <tbody
                        *ngIf="detailForm.controls.Taxes && detailForm.controls.Taxes.length > 0; else bodyNoResultsTaxes"
                        formArrayName="Taxes">
                        <tr *ngFor="let item of detailForm.controls.Taxes.controls; let i=index" [formGroupName]="i">
                          <td>
                            <mat-form-field
                              *ngIf="detailForm.controls.Taxes.controls[i].get('TaxTypeCode').value !== 'ValueAddedTax'"
                              class="allwidth">
                              <mat-select formControlName="TaxTypeCode"
                                [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Taxes.controls[i].controls.TaxTypeCode.valid}"
                                (selectionChange)="onChangeTaxType(i); checkIfExemption()">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let item of invoiceTaxesTypes" [value]="item.ID">{{item.Name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field
                              *ngIf="detailForm.controls.Taxes.controls[i].get('TaxTypeCode').value === 'ValueAddedTax'"
                              class="allwidth">
                              <mat-select formControlName="TaxTypeCode"
                                [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Taxes.controls[i].controls.TaxTypeCode.valid}"
                                (selectionChange)="onChangeTaxType(i); checkIfExemption()">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let item of invoiceTaxesTypesALL" [value]="item.ID">{{item.Name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>
                          <!--TaxTypeOther -->
                          <td *ngIf="!hideColumsTax">
                            <mat-form-field class="allwidth">
                              <mat-select formControlName="TaxSubTypeCode"
                                [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Taxes.controls[i].controls.TaxSubTypeCode.valid}">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let item of invoiceTaxesSubTypes" [value]="item.ID">{{item.Name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>
                          <td *ngIf="!hideColumsTax">
                            <mat-form-field class='allwidth'
                              [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Taxes.controls[i].controls.TaxTypeOther.valid}">
                              <input matInput formControlName='TaxTypeOther'>
                            </mat-form-field>
                          </td>
                          <!-- Percentagem % -->
                          <td>
                            <mat-form-field
                              *ngIf="detailForm.controls.Taxes.controls[i].get('TaxTypeCode').value !== 'ValueAddedTax'"
                              class='allwidth'
                              [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Taxes.controls[i].controls.TaxRate.valid}">
                              <input matInput formControlName='TaxRate' class="text-right one"
                                (change)="valueCalTax(i);valueCalDiscTax()">
                                <i matSuffix>%</i>
                            </mat-form-field>
                            <mat-form-field
                              *ngIf="detailForm.controls.Taxes.controls[i].get('TaxTypeCode').value === 'ValueAddedTax'"
                              class="allwidth">
                              <mat-select formControlName="TaxRate"
                                [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Taxes.controls[i].controls.TaxRate.valid}"
                                (selectionChange)="checkIfExemption();valueCalTax(i);valueCalDiscTax()">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let item of invoiceValueAddedTaxes" [value]="item.TaxPercentage">
                                  {{item.TaxPercentage}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>

                          <!--  Tributavel -->
                          <td *ngIf="!hideColumsTax">
                            <mat-form-field class='allwidth'
                              [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Taxes.controls[i].controls.TaxableAmount.valid}">
                              <input matInput formControlName='TaxableAmount' class="text-right one"
                                (change)="valueCalTax(i);valueCalDiscTax()">
                                <i matSuffix>{{_cur_symbol}}</i>
                            </mat-form-field>
                          </td>

                          <!--  Valor -->
                          <td>
                            <mat-form-field class='allwidth'
                              [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Taxes.controls[i].controls.TaxAmount.valid}">
                              <input matInput formControlName='TaxAmount' class="text-right one"
                                (change)="valueCalTax(i);valueCalDiscTax()">
                                <i matSuffix>{{_cur_symbol}}</i>
                            </mat-form-field>
                          </td>

                          <!--  Observacoes -->
                          <td *ngIf="!hideColumsTax 
                            && !(detailForm.controls.Taxes.controls[i].get('TaxTypeCode').value === 'ValueAddedTax'
                            && detailForm.controls.Taxes.controls[i].get('TaxRate').value === 0)">
                            <mat-form-field class='allwidth'
                              [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Taxes.controls[i].controls.FreeText.valid}">
                              <textarea matInput formControlName='FreeText' class="no-resize" rows="1"></textarea>
                            </mat-form-field>
                          </td>

                          <!-- motivo de isencao -->
                          <td *ngIf="!hideColumsTax
                            && detailForm.controls.Taxes.controls[i].get('TaxTypeCode').value === 'ValueAddedTax'
                            && detailForm.controls.Taxes.controls[i].get('TaxRate').value === 0">
                            <mat-form-field class="allwidth">
                              <mat-label>{{'REASON_FOR_EXEMPTION'|translate}}</mat-label>
                              <mat-select formControlName="VatExemptReasonID"
                                [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Taxes.controls[i].controls.VatExemptReasonID.valid}"
                                (selectionChange)="checkIfExemption()">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let item of invoiceValueAddedTaxesReasons" [value]="item.IntegrationID">
                                  {{item.Norm}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <span *ngIf="formErrors.VatExemptReasonID" class="field-validation-valid text-danger" [translate]
                              [translateParams]="formErrorsParam.VatExemptReasonID">{{ formErrors.VatExemptReasonID }}</span>
                          </td>

                          <td class="text-center">
                            <button type="button" class="btn btn-sm" (click)="removeTaxes(i)"
                              *ngIf="!formDisabled && allDetailsEditable && ((this.invoiceType != 'CreditMemo' && this.invoiceType != 'CreditFinancial') || !disableTaxPanel)">
                              <span title="{{'BUTTON.DELETE' | translate}}">
                                <i class="far fa-trash-alt color-danger backwhite"></i>
                              </span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <ng-template #bodyNoResultsTaxes>
                        <tbody>
                          <tr>
                            <td colspan="8" class="text-center">
                              {{ 'NO_RESULTS_WERE_FOUND' | translate}}
                            </td>
                          </tr>
                        </tbody>
                      </ng-template>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel Descontos -->
        <div class="col-md-6" *ngIf="showPanelDiscounts">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn5"
              (click)="collPn5 = !collPn5">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'DISCOUNTS' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn5, 'fa-caret-up': !collPn5}"></i>
              </h5>
            </div>
            <div id="collPn5" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Lista -->
                <div class="col-md-12 col-sm-12 no-padding">
                  <h6 class="padding-left-15 no-margin-top">
                    <button type="button" class="btn btn-sm" (click)="addDiscounts(true)"
                      *ngIf="!formDisabled && allDetailsEditable">
                      <span title="{{'ADD' | translate}}">
                        <i class="fas fa-plus-square color-success backwhite"></i>
                      </span>
                    </button>
                  </h6>
                  <div class="table-responsive col-md-12 col-sm-12">
                    <div *ngIf="formErrorsDiscounts.length>0" class="validation-summary-errors text-danger col-md-6">
                      <ul>
                        <li *ngFor="let errorMessage of formErrorsDiscounts; let i = index" [translate]
                          [translateParams]="formErrorsDiscountsParam[i]">{{errorMessage}}</li>
                      </ul>
                    </div>
                    <table class="table-bordered">
                      <thead>
                        <tr>
                          <th class="text-center">{{ 'TYPE' | translate}}</th>
                          <th class="text-center">%</th>
                          <th class="text-center">{{ 'VALUE' | translate}}</th>
                          <!-- <th width="30%" class="text-center">{{ 'MULTIPLICATION_FACTOR' | translate}}</th> -->
                          <th class="text-center"></th>
                        </tr>
                      </thead>
                      <tbody
                        *ngIf="detailForm.controls.Discounts && detailForm.controls.Discounts.length > 0; else bodyNoResultsDiscounts"
                        formArrayName="Discounts">
                        <tr *ngFor="let item of detailForm.controls.Discounts.controls; let i=index"
                          [formGroupName]="i">
                          <td>
                            <mat-form-field class='allwidth'
                              [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Discounts.controls[i].controls.DiscountType.valid}">
                              <input matInput formControlName='DiscountType'>
                            </mat-form-field>
                          </td>
                          <td>
                            <mat-form-field class='allwidth'
                              [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Discounts.controls[i].controls.Percentage.valid}">
                              <input matInput formControlName='Percentage' class="text-right one"
                                (change)="valueCalDiscTax()">
                                <i matSuffix>%</i>
                            </mat-form-field>
                          </td>
                          <td>
                            <mat-form-field class='allwidth'
                              [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Discounts.controls[i].controls.Amount.valid}">
                              <input matInput formControlName='Amount' class="text-right one"
                                (change)="valueCalDiscTax()">
                                <i matSuffix>{{_cur_symbol}}</i>
                            </mat-form-field>
                          </td>
                          <!-- <td>
                            <mat-form-field class='allwidth'>
                              <input matInput formControlName='MultiplicationFactor'>
                            </mat-form-field>
                          </td> -->
                          <td class="text-center">
                            <button type="button" class="btn btn-sm" (click)="removeDiscount(i)"
                              *ngIf="!formDisabled && allDetailsEditable">
                              <span title="{{'BUTTON.DELETE' | translate}}">
                                <i class="far fa-trash-alt color-danger backwhite"></i>
                              </span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <ng-template #bodyNoResultsDiscounts>
                        <tbody>
                          <tr>
                            <td colspan="4" class="text-center">
                              {{ 'NO_RESULTS_WERE_FOUND' | translate}}
                            </td>
                          </tr>
                        </tbody>
                      </ng-template>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel Abonos -->
        <div class="col-md-6" *ngIf="showPanelAllowances">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn6"
              (click)="collPn6 = !collPn6">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'ALLOWANCES' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn6, 'fa-caret-up': !collPn6}"></i>
              </h5>
            </div>
            <div id="collPn6" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Lista -->
                <div class="col-md-12 col-sm-12 no-padding">
                  <h6 class="padding-left-15 no-margin-top">
                    <button type="button" class="btn btn-sm" (click)="addAllowances(true)"
                      *ngIf="!formDisabled && allDetailsEditable">
                      <span title="{{'ADD' | translate}}">
                        <i class="fas fa-plus-square color-success backwhite"></i>
                      </span>
                    </button>
                  </h6>
                  <div class="table-responsive col-md-12 col-sm-12">
                    <div *ngIf="formErrorsAllowances.length>0" class="validation-summary-errors text-danger col-md-6">
                      <ul>
                        <li *ngFor="let errorMessage of formErrorsAllowances; let i = index" [translate]
                          [translateParams]="formErrorsAllowancesParam[i]">{{errorMessage}}</li>
                      </ul>
                    </div>
                    <table class="table-bordered">
                      <thead>
                        <tr>
                          <th class="text-center">{{ 'TYPE' | translate}}</th>
                          <th class="text-center">%</th>
                          <th class="text-center">{{ 'VALUE' | translate}}</th>
                          <!-- <th width="30%" class="text-center">{{ 'MULTIPLICATION_FACTOR' | translate}}</th> -->
                          <th class="text-center"></th>
                        </tr>
                      </thead>
                      <tbody
                        *ngIf="detailForm.controls.Allowances && detailForm.controls.Allowances.length > 0; else bodyNoResultsAllowances"
                        formArrayName="Allowances">
                        <tr *ngFor="let item of detailForm.controls.Allowances.controls; let i=index"
                          [formGroupName]="i">
                          <td>
                            <mat-form-field class='allwidth'
                              [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Allowances.controls[i].controls.AllowanceType.valid}">
                              <input matInput formControlName='AllowanceType'>
                            </mat-form-field>
                          </td>
                          <td>
                            <mat-form-field class='allwidth'
                              [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Allowances.controls[i].controls.Percentage.valid}">
                              <input matInput formControlName='Percentage' class="text-right one">
                              <i matSuffix>%</i>
                            </mat-form-field>
                          </td>
                          <td>
                            <mat-form-field class='allwidth'
                              [ngClass]="{ 'mat-input-invalid': !detailForm.controls.Allowances.controls[i].controls.Amount.valid}">
                              <input matInput formControlName='Amount' class="text-right one">
                              <i matSuffix>{{_cur_symbol}}</i>
                            </mat-form-field>
                          </td>
                          <!-- <td>
                            <mat-form-field class='allwidth'>
                              <input matInput formControlName='MultiplicationFactor'>
                            </mat-form-field>
                          </td> -->
                          <td class="text-center">
                            <button type="button" class="btn btn-sm" (click)="removeAllowance(i)"
                              *ngIf="!formDisabled && allDetailsEditable">
                              <span title="{{'BUTTON.DELETE' | translate}}">
                                <i class="far fa-trash-alt color-danger backwhite"></i>
                              </span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <ng-template #bodyNoResultsAllowances>
                        <tbody>
                          <tr>
                            <td colspan="4" class="text-center">
                              {{ 'NO_RESULTS_WERE_FOUND' | translate}}
                            </td>
                          </tr>
                        </tbody>
                      </ng-template>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel referencias -->
        <div class="col-md-12" *ngIf="showPanelReferences">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn7"
              (click)="collPn7 = !collPn7">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'REFERENCES' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn7, 'fa-caret-up': !collPn7}"></i>
              </h5>
            </div>
            <div id="collPn7" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Num Encomenda -->
                <div class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.BuyersOrderNumber.valid}">
                    <mat-label>{{ 'ORDERNUMBER' | translate}}</mat-label>
                    <input matInput formControlName="BuyersOrderNumber">
                    <i matSuffix class="glyphicon glyphicon-new-window link" (click)="selectOrder()" *ngIf="showSelectOrder && detailForm.get('BuyersOrderLineNumber').enabled"></i>
                  </mat-form-field>
                  <span *ngIf="formErrors.BuyersOrderNumber" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.BuyersOrderNumber">{{
                    formErrors.BuyersOrderNumber }}</span>
                </div>
                <!-- Data encomenda -->
                <div class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.BuyersOrderDate.valid}">
                    <mat-label>{{ 'ORDER_DATE' | translate}}</mat-label>
                    <input matInput formControlName="BuyersOrderDate"
                      class="one date-picker">
                      <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                  </mat-form-field>
                  <span *ngIf='formErrors.BuyersOrderDate' class='field-validation-valid text-danger' [translate]
                    [translateParams]="formErrorsParam.BuyersOrderDate">{{
                    formErrors.BuyersOrderDate }}</span>
                </div>
                
                <!-- Nº contrato -->
                <div class="col-md-3 col-sm-12"
                  *ngIf="showDetailsBuyerContractNumber && detailForm.get('BuyerContractNumber').value">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': detailForm.BuyerContractNumber || !detailForm.controls.BuyerContractNumber.valid}">
                    <mat-label>{{ 'CONTRACT_N' | translate}}</mat-label>
                    <input matInput
                      formControlName="BuyerContractNumber">
                  </mat-form-field>
                  <span *ngIf="formErrors.BuyerContractNumber" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.BuyerContractNumber">{{
                    formErrors.BuyerContractNumber }}</span>
                </div>

                <!-- Linha encomenda -->
                <div class="col-md-3 col-sm-12">
                  <mat-form-field class='allwidth'
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.BuyersOrderLineNumber.valid}">
                    <mat-label>{{ 'ORDER_LINE' | translate}}</mat-label>
                    <input matInput formControlName='BuyersOrderLineNumber'>
                  </mat-form-field>
                  <span *ngIf='formErrors.BuyersOrderLineNumber' class='field-validation-valid text-danger'
                    [translate]>{{
                    formErrors.BuyersOrderLineNumber
                    }}
                  </span>
                </div>

                <!-- Data entrega -->
                <div *ngIf="showDeliveryDate" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.DeliveryDate.valid}">
                    <mat-label>{{ 'DELIVERY_DATE' | translate}}</mat-label>
                    <input matInput formControlName="DeliveryDate"
                      class="one date-picker">
                      <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                  </mat-form-field>
                  <span *ngIf='formErrors.DeliveryDate' class='field-validation-valid text-danger' [translate]
                    [translateParams]="formErrorsParam.DeliveryDate">{{
                    formErrors.DeliveryDate }}</span>
                </div>
                <!-- Num guia -->
                <div *ngIf="hideNumGuia" class="col-md-3 col-sm-12">
                  <mat-form-field class='allwidth'
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.SuppliersDeliveryNoteNumber.valid}">
                    <mat-label>{{ 'DELIVERY_GUIDE_NUMBER' | translate}}</mat-label>
                    <input matInput
                      formControlName='SuppliersDeliveryNoteNumber'>
                  </mat-form-field>
                  <span *ngIf='formErrors.SuppliersDeliveryNoteNumber' class='field-validation-valid text-danger'
                    [translate]>{{
                    formErrors.SuppliersDeliveryNoteNumber }}</span>
                </div>
                <!-- Centro custo -->
                <div class="col-md-3 col-sm-12" *ngIf="showBuyersCostCenter">
                  <mat-form-field class='allwidth'
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.BuyersCostCenter.valid}">
                    <mat-label>{{ 'BUYER_COST_CENTER' | translate}}</mat-label>
                    <input matInput
                      formControlName='BuyersCostCenter'>
                  </mat-form-field>
                  <span *ngIf='formErrors.BuyersCostCenter' class='field-validation-valid text-danger' [translate]>{{
                    formErrors.BuyersCostCenter
                    }}
                  </span>
                </div>
                <!-- Num lote -->
                <div *ngIf="showBacthNumber" class="col-md-3 col-sm-12">
                  <mat-form-field class='allwidth'
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.BatchNumber.valid}">
                    <mat-label>{{ 'LOT' | translate}}</mat-label>
                    <input matInput formControlName='BatchNumber'>
                  </mat-form-field>
                  <span *ngIf='formErrors.BatchNumber' class='field-validation-valid text-danger' [translate]>{{
                    formErrors.BatchNumber
                    }}
                  </span>
                </div>
                <!-- Data validade -->
                <div *ngIf="showBacthExpiryDate" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth"
                    [ngClass]="{ 'mat-input-invalid': !detailForm.controls.BatchExpiryDate.valid}">
                    <mat-label>{{ 'EXPIRATION_DATE' | translate}}</mat-label>
                    <input matInput formControlName="BatchExpiryDate"
                      class="one date-picker">
                      <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                  </mat-form-field>
                  <span *ngIf='formErrors.BatchExpiryDate' class='field-validation-valid text-danger' [translate]
                    [translateParams]="formErrorsParam.BatchExpiryDate">{{
                    formErrors.BatchExpiryDate }}</span>
                </div>
                <!-- Outras referencias -->
                <div class="col-md-12 col-sm-12 no-padding" *ngIf="!hideDetailOtherReferences">
                  <h6 class="padding-left-15">
                    <strong>{{ 'OTHER_REFERENCES' | translate}}&nbsp;&nbsp;</strong>
                    <button type="button" class="btn btn-sm" (click)="addOtherReferences(true)"
                      *ngIf="!formDisabled && allDetailsEditable">
                      <span title="{{'ADD' | translate}}">
                        <i class="fas fa-plus-square color-success backwhite"></i>
                      </span>
                    </button>
                  </h6>
                  <div class="table-responsive col-md-12 col-sm-12">
                    <div *ngIf="formErrorsOtherReferences.length>0"
                      class="validation-summary-errors text-danger col-md-6">
                      <ul>
                        <li *ngFor="let errorMessage of formErrorsOtherReferences; let i = index" [translate]
                          [translateParams]="formErrorsOtherReferencesParam[i]">{{errorMessage}}</li>
                      </ul>
                    </div>
                    <table class="table-bordered">
                      <thead>
                        <tr>
                          <th width="35%" class="text-center">{{ 'TYPE' | translate}}</th>
                          <th width="35%" class="text-center">{{ 'VALUE' | translate}}</th>
                          <th width="20%" class="text-center">{{ 'DATE' | translate}}</th>
                          <th width="10%" class="text-center"></th>
                        </tr>
                      </thead>
                      <tbody
                        *ngIf="detailForm.controls.OtherReferences && detailForm.controls.OtherReferences.length > 0; else bodyNoResultsOtherReferences"
                        formArrayName="OtherReferences">
                        <tr *ngFor="let item of detailForm.controls.OtherReferences.controls; let i=index"
                          [formGroupName]="i">
                          <td>
                            <!-- Tipo Descritivo -->
                            <mat-form-field class="allwidth" *ngIf="!showOthersReferencesTypes">
                              <input matInput formControlName="ReferenceType">
                            </mat-form-field>
                            <!-- Lista de Tipos -->
                            <mat-form-field class="full-width" *ngIf="showOthersReferencesTypes">
                              <mat-select formControlName="ReferenceType">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let item of otherReferenceTypes" [value]="item.ItemCode">
                                  {{item.ItemName}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>
                          <td>
                            <mat-form-field class='allwidth'
                              [ngClass]="{ 'mat-input-invalid': !detailForm.controls.OtherReferences.controls[i].controls.ReferenceValue.valid}">
                              <input matInput formControlName='ReferenceValue'>
                            </mat-form-field>
                          </td>
                          <td>
                            <mat-form-field class="allwidth"
                              [ngClass]="{ 'mat-input-invalid': !detailForm.controls.OtherReferences.controls[i].controls.ReferenceDate.valid}">
                              <input matInput formControlName="ReferenceDate" class="one date-picker">
                                <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                            </mat-form-field>
                          </td>
                          <td class="text-center">
                            <button type="button" class="btn btn-sm" (click)="removeOtherReferences(i)"
                              *ngIf="!formDisabled && allDetailsEditable">
                              <span title="{{'BUTTON.DELETE' | translate}}">
                                <i class="far fa-trash-alt color-danger backwhite"></i>
                              </span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <ng-template #bodyNoResultsOtherReferences>
                        <tbody>
                          <tr>
                            <td colspan="4" class="text-center">
                              {{ 'NO_RESULTS_WERE_FOUND' | translate}}
                            </td>
                          </tr>
                        </tbody>
                      </ng-template>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel observacoes-->
        <div class="col-md-12" *ngIf="showPanelObservations">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn8"
              (click)="collPn8 = !collPn8">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'OBSERVATIONS' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn8, 'fa-caret-up': !collPn8}"></i>
              </h5>
            </div>
            <div id="collPn8" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': formErrors.FreeText || !detailForm.controls.FreeText.valid}">
                    <textarea matInput formControlName="FreeText" class="no-resize" rows="3"></textarea>
                  </mat-form-field>
                  <span *ngIf="formErrors.FreeText" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.FreeText">{{formErrors.FreeText}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- close panel -->
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right modal-theme" *ngIf="detailForm.enabled">
      <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}"
        (click)="resetForm();dialogRef.close(null)">
        {{'BUTTON.CANCEL' | translate}}
      </button>
      <button *ngIf="!formDisabled || enableSaveButton" type="button" class="btn btn-primary"
        title="{{'BUTTON.SAVE' | translate}}" (click)="save()" [disabled]="!detailForm.valid || (!changedForm && enableSavingWhenChangingForm)">
        {{'BUTTON.SAVE' | translate}}
      </button>
    </div>

    <div class="full-width text-right modal-theme" *ngIf="detailForm.disabled">
      <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="dialogRef.close(null)">
        {{'CLOSE' | translate}}
      </button>
    </div>

  </div>
</div>